var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cus-chat-supervise" },
    [
      _c(
        "div",
        { staticClass: "cus-chat-supervise-search" },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "群名称：" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", clearable: "" },
                    on: { change: _vm.selectBindStatus },
                    model: {
                      value: _vm.formInline.chatName,
                      callback: function($$v) {
                        _vm.$set(_vm.formInline, "chatName", $$v)
                      },
                      expression: "formInline.chatName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "群主：" } },
                [
                  _c("el-input", {
                    attrs: { size: "mini", clearable: "" },
                    on: { change: _vm.selectBindStatus },
                    model: {
                      value: _vm.formInline.ownerName,
                      callback: function($$v) {
                        _vm.$set(_vm.formInline, "ownerName", $$v)
                      },
                      expression: "formInline.ownerName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "群标签：" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.tagList,
                      props: _vm.tagProps,
                      size: "mini",
                      "show-all-levels": false
                    },
                    on: { change: _vm.selectTagItem },
                    model: {
                      value: _vm.searchTagItem,
                      callback: function($$v) {
                        _vm.searchTagItem = $$v
                      },
                      expression: "searchTagItem"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "建群时间：" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      size: "small"
                    },
                    on: { change: _vm.selectBindStatus },
                    model: {
                      value: _vm.date,
                      callback: function($$v) {
                        _vm.date = $$v
                      },
                      expression: "date"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最近聊天时间：" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      size: "small"
                    },
                    on: { change: _vm.selectBindStatus2 },
                    model: {
                      value: _vm.date2,
                      callback: function($$v) {
                        _vm.date2 = $$v
                      },
                      expression: "date2"
                    }
                  })
                ],
                1
              ),
              _vm.isShow
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.handleDta,
                              expression: "handleDta"
                            }
                          ],
                          attrs: { size: "small" },
                          on: { click: _vm.handleGetData }
                        },
                        [_vm._v("同步数据")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { ref: "tableWrapper", staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              ref: "cusChatTable",
              attrs: {
                size: "small",
                data: _vm.tableData,
                fit: "",
                "highlight-current-row": "",
                align: "center",
                "header-cell-style": { background: "#eef1f6" },
                height: _vm.tableHeight
              },
              on: {
                "sort-change": _vm.tableSort,
                "selection-change": _vm.handleSelectionChange
              }
            },
            [
              !_vm.isShow
                ? _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "chatName",
                  label: "群名称",
                  "show-overflow-tooltip": "",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "ownerName", label: "群主", align: "center" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "groupChatTagDetailDtoList",
                  label: "群标签",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(
                        scope.row.groupChatTagDetailDtoList,
                        function(item) {
                          return _c(
                            "el-tag",
                            {
                              key: item.tagId,
                              staticStyle: { margin: "3px" },
                              attrs: { size: "small" }
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-start",
                                    width: "150",
                                    trigger: "hover"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(_vm._s(item.tagName))]
                                  ),
                                  _vm._l(
                                    scope.row.groupChatTagDetailDtoList,
                                    function(item) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: item.tagId,
                                          staticStyle: { margin: "3px" },
                                          attrs: {
                                            size: "small",
                                            closable: ""
                                          },
                                          on: {
                                            close: function($event) {
                                              return _vm.deleteGroupTag(
                                                scope.row.chatId,
                                                item.tagId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(item.tagName))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }
                      )
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "memNum", label: "群人数", align: "center" }
              }),
              _vm.isShow
                ? _c("el-table-column", {
                    attrs: {
                      prop: "memQuitNum",
                      label: "退群人数",
                      align: "center"
                    }
                  })
                : _vm._e(),
              _vm.isShow
                ? _c("el-table-column", {
                    attrs: {
                      prop: "dayMemQuitNum",
                      label: "当天进群/退群人数",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.dayMemJoinNum > 0
                                      ? "+" + scope.row.dayMemJoinNum
                                      : 0
                                  ) +
                                    "/" +
                                    _vm._s(
                                      scope.row.dayMemQuitNum > 0
                                        ? "-" + scope.row.dayMemQuitNum
                                        : 0
                                    )
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2485252834
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "建群时间",
                  align: "center",
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastActivityTime",
                  label: "最近聊天时间",
                  align: "center",
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.lastActivityTime || "--"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm.isShow
                ? _c("el-table-column", {
                    attrs: {
                      prop: "operation",
                      label: "操作",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.handleDetail,
                                      expression: "handleDetail"
                                    }
                                  ],
                                  attrs: { underline: false, type: "text" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.viewDetail(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("详情")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.handleTag,
                                      expression: "handleTag"
                                    }
                                  ],
                                  attrs: { underline: false, type: "text" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.tagClick(
                                        scope.row.chatId,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("打标签")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.handleChat,
                                      expression: "handleChat"
                                    }
                                  ],
                                  attrs: { underline: false, type: "text" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.viewContent(
                                        scope.$index,
                                        scope.row
                                      )
                                    }
                                  }
                                },
                                [_vm._v("聊天记录")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3938046434
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.chatTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "50%",
            center: true,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c(
            "div",
            {},
            [
              _vm.newEditionDialogVisible
                ? _c("GroupChatDia", { attrs: { idData: _vm.uid } })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm.tagVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "群标签",
                visible: _vm.tagVisible,
                "close-on-click-modal": false,
                width: "50%",
                "close-on-press-escape": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.tagVisible = $event
                }
              }
            },
            [
              _c("Tag", {
                attrs: { "is-show": false, currentRow: _vm.currentRow },
                on: {
                  addTag: _vm.addGroupTag,
                  handleBack: function($event) {
                    _vm.tagVisible = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }